<template>
  <div id="account">
    <call />
    <pop-alert />
    <!-- header -->
    <top-bar title="マイページ" backUrl="/"/>
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app></footer-app>
      <!-- identification -->
      <section v-show="!loading">
        <div :class="{'fade-base p-16': true, 'fade': pageFade}">
          <div class="l-auth__box">
            <!-- <div class="announce-mobileorder" v-if="isMobileOrderEnabled() && isLogin && isSMSValid">
              <p>モバイルオーダーのご利用が可能です。<br />
              モバイルオーダーボタンを押して商品をお選び下さい。</p>
            </div> -->
            <div class="l-auth__title mt-16">アカウント連携</div>
            
            <div class="l-auth__box l-auth__box--sm l-box-account" v-if="loginType && 0 < loginType.length">
              <div class="notice-mobileorder mb-15" v-if="isMobileOrderEnabled()">
                一部機能をご利用いただくには、アカウント連携が必要です。
              </div>
              <a v-if="loginType == 'line'" href="" class="btn-outline-auth font-bold" @click.prevent="showCommonAccountModal('logout')">LINEアカウントで連携中</a>
              <a v-if="loginType == 'apple'" href="" class="btn-outline-auth font-bold" @click.prevent="showCommonAccountModal('logout')">
                <div class="d-flex align-items-center"><img class="mr-5" src="/assets/images/icon/icon-apple-black.svg" alt="">Appleアカウントで連携中</div>
              </a>
              <a v-if="loginType == 'google'" href="" class="btn-outline-auth font-bold" @click.prevent="showCommonAccountModal('logout')">
                Googleアカウントで連携中
              </a>
              <div v-on:click.stop.prevent="showAccountModal" class="l-box-account__link text-center mt-16">
                <a class="decoration-none mr-5" href="#">アカウント削除</a>
                <img src="/assets/images/icon/icon-right-grey.svg" height="10" alt="">
              </div>
            </div>
            <div class="l-auth__box l-auth__box--sm l-box-account" v-else>
              <div class="notice-mobileorder mb-15">
                一部機能をご利用いただくには、アカウント連携が必要です。
              </div>
              <router-link to="/account/login?from-page=/account/profile" class="btn-outline-auth btn-large font-bold">
                連携する
                <b class="color-5 icon-login">
                  未連携
                  <img src="/assets/images/icon/icon-play-active.svg" alt="">
                </b>
              </router-link>
            </div>

            <div class="l-auth__box l-auth__box--sm l-box-account">
              <div class="l-auth__title l-auth__title--sm mb-15">お気に入り店舗</div>
              <div class="l-auth__group-button h-auto">
                <div v-on:click.stop.prevent="showFavoriteShop()"  class="btn-outline-auth font-bold">
                  {{shopData && shopData.name}}
                  <img src="/assets/images/icon/icon-right-grey.svg" alt="">
                </div>
              </div>
            </div>

            <div class="l-auth__box l-auth__box--sm l-box-account">
              <div class="l-auth__title l-auth__title--sm mb-15">お客さま情報</div>
              <div class="l-auth__group-button h-auto">
                <div v-on:click.stop.prevent="showRegistrationPage()" class="btn-outline-auth font-bold mb-10">
                  性別：{{gender}}
                  <img src="/assets/images/icon/icon-right-grey.svg" alt="">
                </div>
                <div v-on:click.stop.prevent="showRegistrationPage()" class="btn-outline-auth font-bold mb-10">
                  生年月：{{user && user.birthdayYear}}年{{user && user.birthdayMonth}}月
                  <img src="/assets/images/icon/icon-right-grey.svg" alt="">
                </div>
                <div v-on:click.stop.prevent="showRegistrationPage()" class="btn-outline-auth font-bold">
                  郵便番号：{{user && user.zipcode}}
                  <img src="/assets/images/icon/icon-right-grey.svg" alt="">
                </div>
              </div>
            </div>
            <div class="l-auth__box l-auth__box--sm l-box-account">
              <div class="l-auth__title l-auth__title--sm">通知設定</div>
              <div class="btn-outline-auth font-bold" @click.prevent="open_setting">
                通知設定
                <img src="/assets/images/icon/icon-right-grey.svg" alt="">
              </div>
            </div>

            <!-- <div v-if="showSwitchNavigation" class="l-auth__box l-auth__box--sm l-box-account pb-50">
              <div class="l-auth__title l-auth__title--sm mb-16">3ボタンナビゲーション表示設定</div>
              <div class="c-radio__place c-btn-two__box">
              <div class="c-btn c-btn--no-arrow c-btn--border" @click.prevent="switchNavigation('show')">
                <div :class="`font-size-15 ${switchNavigationFlag == 'show' ? 'color-4':''}`">表示</div>
              </div>
              <div class="c-btn c-btn--no-arrow c-btn--border" @click.prevent="switchNavigation('hide')">
                <div :class="`font-size-15 ${switchNavigationFlag == 'hide' ? 'color-4':''}`">非表示</div>
              </div>
              </div>

              <div v-if="verAndroid >= 10" class="c-btn c-btn--center c-btn--white c-btn--white--multi" @click.prevent="open_navigation_setting">
                <span class="font-size-15">端末ナビゲーション設定</span>
              </div>
              <div v-if="verAndroid >= 10" class="mt-8 pl-16">
                <small>表示が切り替わらない場合、端末ナビゲーション設定から端末の設定を変更してください。</small>

              </div>
            </div> -->
          </div>
        </div>
      </section>
      
      <div id="account-popup" class="l-shop l-shop--detail l-shop-overlay fixed" v-if="showModal" style=" z-index: 201;">
        <div class="p-0 fixed" style="width: calc(100% - 30px);max-height: calc(100vh - 60px);">
          <div class="text-right" @click="closeAccountModal()">
            <img src="/assets/images/icon/icon-close.svg" alt="" />
          </div>
          <div class="c-modal__dialog--center c-modal__content">
            <template v-if="showAcountDialog == 1">
              <div class="w-100 text-center">
                <div class="mb-30 font-bold font-size-18 mt-32">アカウント削除</div>
                <div class="pt-32 border-top font-bold font-size-15 content-modal-auth">登録されているアカウントの<br />削除を行いますか？</div>
                <div class="btn-tutorial mt-32 mx-auto mb-30" @click.prevent="nextAccountModal()">
                    確認
                </div>
              </div>
            </template>
              
            <template v-else-if="showAcountDialog == 2">
              <div class="w-100 text-center">
                <div class="mb-30 font-bold font-size-18 mt-32">アカウント削除</div>
                <div class="pt-32 border-top font-bold font-size-15 content-modal-auth color-2">
                  <div class="text-center "><img src="/assets/images/icon/icon-warning.svg" width="90px"></div>
                  <b>現在登録されているアプリのデータが全て削除されます。よろしいですか？</b>
                </div>
                <div class="btn-tutorial mt-32 mx-auto mb-30" @click.prevent="withdrawal()">
                  削除
                </div>
              </div>
            </template>
            <template v-else-if="showAcountDialog == 3">
              <div class="w-100 text-center">
                <div class="mb-30 font-bold font-size-18 mt-32">アカウント削除</div>
                <div class="pt-32 border-top font-bold font-size-15 content-modal-auth">完了していない注文や予約があるため削除できません。注文状況・履歴をご確認下さい。</div>
                <div class="btn-tutorial mt-32 mx-auto mb-30" @click.prevent="notAcountDeleteFunc()">
                  注文状況・履歴へ
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>  

       <div id="c-account-popup" class="l-shop l-shop--detail l-shop-overlay fixed" v-if="showCommonAcountModal" style=" z-index: 201;">
        <div class="p-0 fixed" style="width: calc(100% - 30px);max-height: calc(100vh - 60px);">
          <div class="text-right" @click="closeCommonAccountModal()">
            <img src="/assets/images/icon/icon-close.svg" alt="" />
          </div>
          <div class="c-modal__dialog--center c-modal__content">
            <template v-if="showCommonAcountDialog == 'logout'">
              <div class="w-100 text-center">
                <div class="mb-30 font-bold font-size-18 mt-32">
                  {{loginType == 'line' ? 'LINE' : loginType == 'apple' ? 'Apple' : 'Google'}}アカウントで連携中
                </div>
                <div class="pt-32 border-top font-bold font-size-15 content-modal-auth">
                  登録されているアカウントの<br />
                  連携を解除しますか？
                </div>
                <div class="btn-tutorial mt-32 mx-auto mb-30" v-on:click.stop.prevent="logout">
                  連携を解除する
                </div>
              </div>
            </template>
            <template v-if="showCommonAcountDialog == 'credit'">
              <div class="w-100 text-center">
                <div class="mb-30 font-bold font-size-18 mt-32">登録クレジットカード削除</div>
                <div class="pt-32 border-top font-bold font-size-15 content-modal-auth">登録されているクレジットカードの<br />削除を行いますか？</div>
                <div class="btn-tutorial mt-32 mx-auto mb-30" @click.prevent="removeAeonRegi">
                  削除
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>  
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import { Common, eventBus } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { deleteUserAeonRegi, deleteMyOrders, getShop, getUserAeonRegi, getNotCompletedMyOrders, getProvider } from "../store/firestore.js";
import { DB } from "../config/const.js";
import PopAlert from "../components/PopAlert.vue";
import TopBar from "../components/TopBar.vue";

export default Vue.extend({
  name: "Profile",
  components: {
    'footer-app': Footer,
    PopAlert,
    TopBar,
  },
  mixins: [Tenant],
  data() {
    return {
      showSwitchNavigation: false,
      verAndroid: '',
      loginType: '',
      user: {},
      gender: '',
      uid: '',
      shopData: undefined,
      aeonRegiList: [],
      showModal:false,
      showAcountDialog:1,
      notCompletedOrders: [],
      showCommonAcountDialog:'',
      showCommonAcountModal:false,
      switchNavigationFlag: '',
      loading: false,
    }
  },
  async created() {
    this.loading = true;
    if (!this.$store.state.shopId) {
      this.$router.push("/storeselect");
      return;
    }
    this.$store.dispatch('initialiseStore');
    this.loginType = this.$store.state.loginType;
    this.getUser();
    this.shopData = await getShop(this.shopId);
    eventBus.$on('logoutError', (message) => {
      console.log(message);
      this.alert("システムエラーのため、ログアウトできませんでした。");
    })
  
   this.switchNavigationFlag = Common.getNavigationState();

    const supportVersion = "1.2.8";
    if (Common.isAndroid() && this.isVersionGte(supportVersion)) {
      // android & バージョン1.2.8以上
      this.showSwitchNavigation = true;
      this.verAndroid = parseInt(Common.verAndroid());
    }
    this.loading = false;
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async getUser() {
      if (!this.$store.state.userId && this.$store.state.userId.length == 0) {
        return;
      }
      this.uid = this.$store.state.userId;
      var docRef = DB.collection('user').doc(this.$store.state.userId);
      var user = await docRef.get();
      this.user = user.data();
      if (this.user?.gender == 1) {
        this.gender = '女性';
      } else if (this.user?.gender == 2) {
        this.gender = '男性';
      } else if (this.user?.gender == 0) {
        this.gender = '回答しない';
      }
      this.aeonRegiList = await getUserAeonRegi(this.$store.state.userId, this.shopId) || [];
    },
    async logout() {
       this.closeCommonAccountModal()
      // ネイティブでログアウト
      Common.loadingShow();
      let loginType = this.$store.state.loginType;
      if (loginType == 'apple') {
        Common.messageHandlers('apple_logout');
      } else if (loginType == 'line') {
        Common.messageHandlers('line_logout');
      } else if (loginType == 'google') {
        Common.messageHandlers('google_logout');
      }
      this.$store.dispatch('snsLogout');
      this.loginType = '';
      this.isLogin = false;
      //カートクリアする
      await this.$store.dispatch('clearCart');
    },
    async withdrawal() {
      // ネイティブでアカウント削除
      Common.loadingShow();
      await deleteUserAeonRegi(this.$store.state.userId);
      await deleteMyOrders(this.$store.state.userId);
      let loginType = this.$store.state.loginType;
      if (loginType == 'apple') {
        Common.messageHandlers('apple_withdrawal');
      } else if (loginType == 'line') {
        Common.messageHandlers('line_withdrawal');
      } else if (loginType == 'google') {
        Common.messageHandlers('google_withdrawal');
      }
      this.$store.dispatch('snsLogout');
      this.loginType = '';
      this.isLogin = false;
      //カートクリアする
      await this.$store.dispatch('clearCart');
      this.closeAccountModal()
    },
    showRegistrationPage() {
      this.$router.push('/account/registration?from-page=/account/profile');
    },
    async removeAeonRegi() {
      this.closeCommonAccountModal()
      await deleteUserAeonRegi(this.$store.state.userId);
      this.aeonRegiList = [];
    },
    switchNavigation(view) {
        this.switchNavigationFlag = view;
        Common.setNavigationState(view);
    },
    open_setting() {
      Common.messageHandlers("open_setting");
    },
    open_navigation_setting() {
      Common.messageHandlers("open_navigation_setting");
    },
    showFavoriteShop() {
      this.$router.push('/account/favoritestore');
    },
    showAccountModal() {
      this.showModal = true
    },
    async nextAccountModal() {
      this.showAcountDialog =  2
    },
    closeAccountModal() {
      this.showModal = false
      this.showAcountDialog =  1
    },
    async notAcountDeleteFunc() {
      //注文履歴へ遷移
      const notCompletedOrder = this.notCompletedOrders[0];
      const tenantId = notCompletedOrder.tenantId;
      const provider = await getProvider(tenantId);
      if (provider.shopId != this.shopId) {
        this.$store.dispatch('setShopId', provider.shopId).then(() => {
          this.$router.push('/mobileorder/history')
        });
      } else {
        this.$router.push('/mobileorder/history')
      }
    },
    showCommonAccountModal(type) {
      this.showCommonAcountModal = true
      this.showCommonAcountDialog = type
    },
    closeCommonAccountModal() {
      this.showCommonAcountModal = false
      this.showCommonAcountDialog =  ''
    },
  }
})
</script>
